import React from 'react';
import './viewSlider.css';

function ViewSlider({ currentView, onViewChange }) {
  const views = [
    { id: 'waiting', icon: '🕐', label: 'Warteraum' },
    { id: 'video', icon: '📹', label: 'Video-Ansicht' },
    { id: 'quiz', icon: '🎓', label: 'Quiz' },
    { id: 'whiteboard', icon: '🖊️', label: 'Whiteboard' },
    { id: 'success', icon: '🏆', label: 'Erfolgsseite' }
  ];

  const currentViewIndex = views.findIndex(view => view.id === currentView);
  // Für horizontalen Slider: Position prozentual berechnen
  const stepPct = 100 / views.length;
  const thumbPosition = currentViewIndex >= 0 ? (currentViewIndex * stepPct) + (stepPct / 2) : (stepPct / 2);

  const handleStopClick = (viewId) => {
    onViewChange(viewId);
  };

  return (
    <div className="viewSliderContainer">
      <div className="viewSliderTrack">
        <div 
          className="viewSliderThumb"
          style={{ left: `${thumbPosition}%` }}
        >
          ●
        </div>
        
        <div className="viewSliderStops">
          {views.map((view) => (
            <div
              key={view.id}
              className={`viewSliderStop ${view.id === currentView ? 'active' : ''}`}
              onClick={() => handleStopClick(view.id)}
            >
              <span>{view.icon}</span>
              <div className="viewSliderLabel">{view.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ViewSlider;